<div
  class="__table-wrap"
  [class.is-loading]="isLoading">
  <vshc-item-list-table
    [items]="items"
    [columns]="columns"
    [disableHover]="disableTableHover"
    [count]="items?.length"
    [paginatorLength]="paginatorLength"
    [paginatorPageSize]="paginatorPageSize"
    [showAll]="showAll$ | async"
    [mode]="mode"
    [colsTranslations]="colsTranslations"
    [currentPage]="currentPage"
    [linkPath]="tableLink"
    [customClassProperty]="customClassProperty"
    [columnTemplateMap]="colTemplatesMap"
    [actionsTemplates]="actionTemplates"
    [itemStateTemplate]="itemStateTemplateRef"
    [defaultSort]="defaultSort"
    [defaultSortDirection]="defaultSortDirection"
    [trackBy]="trackBy"
    (page)="page.emit($event)"
    (sorted)="sorted.emit($event)"
    (clicked)="tableRowClicked.emit($event)"
    (showChanged)="showAll$.next($event)">
  </vshc-item-list-table>
</div>
